import { Link } from 'react-router'
import { cn } from '#app/utils/misc'

/**
 * The convergence mark — lines/nodes flowing into a single point.
 * Clearspace = the center dot's diameter. Never recolour outside the accent range.
 */
export function BrandMark({
	className,
	size = 30,
	tone = 'brand',
}: {
	className?: string
	size?: number
	/** `brand` = violet on light, `inverse` = violet lines + white nodes for dark surfaces */
	tone?: 'brand' | 'inverse'
}) {
	const line = tone === 'inverse' ? '#7A5CFF' : '#5B4BFF'
	const dot = tone === 'inverse' ? '#FFFFFF' : '#7A5CFF'
	const core = tone === 'inverse' ? '#7A5CFF' : '#5B4BFF'
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 30 30"
			fill="none"
			aria-hidden="true"
			className={className}
		>
			<circle cx="15" cy="15" r="3.4" fill={core} />
			<g stroke={line} strokeWidth="1.5" strokeLinecap="round" opacity="0.9">
				<line x1="15" y1="15" x2="3" y2="4" />
				<line x1="15" y1="15" x2="27" y2="6" />
				<line x1="15" y1="15" x2="2" y2="20" />
				<line x1="15" y1="15" x2="26" y2="24" />
				<line x1="15" y1="15" x2="13" y2="2" />
			</g>
			<g fill={dot}>
				<circle cx="3" cy="4" r="2" />
				<circle cx="27" cy="6" r="2.4" />
				<circle cx="2" cy="20" r="1.8" />
				<circle cx="26" cy="24" r="2.2" />
				<circle cx="13" cy="2" r="1.6" />
			</g>
		</svg>
	)
}

/**
 * Full wordmark lockup. The wordmark always shows the literal domain — it's our SEO asset.
 */
export function BrandLogo({
	className,
	markSize = 30,
	textClassName,
	to = '/',
}: {
	className?: string
	markSize?: number
	textClassName?: string
	to?: string
}) {
	return (
		<Link
			to={to}
			aria-label="competitorbacklinks.com home"
			className={cn('text-ink flex items-center gap-[11px]', className)}
		>
			<BrandMark size={markSize} />
			<span
				className={cn(
					'font-display text-ink text-[19px] font-bold tracking-[-0.02em]',
					textClassName,
				)}
			>
				competitorbacklinks
				<span className="font-semibold text-[#9A968C]">.com</span>
			</span>
		</Link>
	)
}
